import { Assessment } from "../../models";
import { GraphQLIssueDAOFactory } from "../../lib/issue/dao/graphql/GraphQLIssueDAOFactory";
import { QuickQuoteSubmission } from "./QuickQuoteSubmission";
import { graphQLAssessmentDAO } from "../../lib/assessment/GraphQLAssessmentDAO";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";

const issueDAO = GraphQLIssueDAOFactory.getInstance();

export const QuickQuoteAssessment = () => {
    const { assessmentId } = useParams<{ assessmentId: string; }>();

    const { data: assessment, isLoading: assessmentLoading, isError: assessmentError } = useQuery<Assessment>({
        queryKey: ['assessment', assessmentId],
        queryFn: async () => {
            return await graphQLAssessmentDAO.getAssessmentById(assessmentId);
        }
    });

    const { data: issue, isLoading: issueLoading, isError: issueError } = useQuery({
        queryKey: ['issue', assessment],
        queryFn: async () => {
            if (typeof assessment?.issueIds?.[0] !== 'string') {
                return;
            }
            return await issueDAO.getIssueById(assessment.issueIds[0]);
        },
        enabled: !!assessment?.issueIds && typeof assessment.issueIds[0] === 'string'
    });

    return (
        <>
            {assessmentError && <div>Error fetching assessment</div>}
            {issueError && <div>Error fetching issue</div>}
            {assessmentLoading || issueLoading && <div>Loading...</div>}
            {issue &&
                <QuickQuoteSubmission issue={issue} />
            }
        </>
    );
}